import React, { useReducer, createContext, useEffect } from 'react'
import reducer, { propsToState } from './reducer'
import { actionCreators } from './actions'
import { getWealthManagerReminders } from './effects'

export const RemindersContext = createContext(null)

export const RemindersProvider = (props) => {
  const [state, dispatch] = useReducer(
    reducer,
    propsToState(props))
  const actionsWithDispatch = actionCreators(dispatch, state)
  const { updateProps } = actionsWithDispatch

  useEffect(
    () => updateProps(props),
    [props.reminders]
  )

  useEffect(
    () => getWealthManagerReminders(state, dispatch),
    []
  )

  return (
    <RemindersContext.Provider value={{ state, actions: actionsWithDispatch }}>
      {props.children}
    </RemindersContext.Provider>
  )
}
